import { useEffect, useState } from 'react';
import axios from 'axios';
import { fetchAllDiscounts } from '../utils/_getDiscounts';
import { groupDatesByMonth } from '../utils/calendarUtils';

export const useDateChoiceData = (rooms) => {
  const [dates, setDates] = useState({});
  const [allowedLengths, setAllowedLengths] = useState([]);
  const [discounts, setDiscounts] = useState([]);

  useEffect(() => {
    if (rooms.length > 0) {
      setAllowedLengths(
        Array.from(
          new Set(
            rooms.flatMap((room) =>
              room.people.map((person) => Number(person.program_length)).filter(Boolean)
            )
          )
        )
      );
    }

    axios
      .get('https://kivach.ru/calc-new/api_new.php?method=program_dates&lengths')
      .then(({ data }) => setDates(groupDatesByMonth(data.res)));

    fetchAllDiscounts(rooms).then(setDiscounts);
  }, [rooms]);

  return { dates, allowedLengths, discounts };
};
